import { useMemo, useRef, useState } from 'react';

import { DataGridProps, Icons } from '@thirdspacelearning/library';

import DataGridToolbar from './DataGridToolbar';
import DataGridFilterPanel from './DataGridFilterPanel';

const useDataGridToolbar = () => {
    const filterPanelEl = useRef(null);
    const [filterButtonEl, setFilterButtonEl] =
        useState<HTMLButtonElement | null>(null);

    const slots = useMemo(
        (): Partial<DataGridProps['slots']> => ({
            toolbar: DataGridToolbar,
            filterPanel: DataGridFilterPanel,
            filterPanelDeleteIcon: () => <Icons.DeleteOutlined />,
            moreActionsIcon: () => <Icons.MoreVert />,
        }),
        [],
    );

    const slotProps = useMemo(
        (): Partial<DataGridProps['slotProps']> => ({
            toolbar: {
                filterPanelEl,
                setFilterButtonEl,
            },
            panel: {
                target: filterButtonEl ?? undefined,
            },
            basePopper: {
                placement: 'bottom',
            },
            baseSelect: { native: false },
        }),
        [filterButtonEl],
    );

    return { filterPanelEl, slots, slotProps };
};

export default useDataGridToolbar;
